<template>
  <SelectorPanel
    type="grdReporting"
    text="Reporting"
    :disabled="disabled"
    :force-close="forceClose"
    :url-path="urlPath"
    :disable-close="true"
    :force-full-screen="true"
  >
    <SelectorPanelHeader
      type="grdReporting"
      title="Reporting"
      :hide-close="true"
      @click-close="handleClickClose"
    >
    </SelectorPanelHeader>

    <ReportBuilder class="report-builder"></ReportBuilder>
  </SelectorPanel>
</template>

<script>
export default {
  name: "GrdReportingSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    ReportBuilder: () => import("@/components/reporting/ReportBuilder"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    forceClose: null,
    urlPath: "/grd/reporting",
  }),
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
  },
};
</script>

<style scoped></style>
